import { keyframes } from "styled-components";

export const blinker = keyframes`
  0% {
    box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 0.09);
  }
  50% {
    box-shadow:  0px 0px 0px 4px rgba(255, 255, 255, 0.09);
  }
  100% {
    box-shadow:  0px 0px 0px 4px rgba(255, 255, 255, 0.00);
  }
`;
